import { resolveCatalogInstructor } from "../../../common/catalog/catalogInstructorDisplay";

export default function SummarySection({ webinar }) {
	const instructor = resolveCatalogInstructor(webinar);

	return (
		<div className="bg-white rounded-[10px] p-[10px]">
			<div className="flex flex-row">
				<div>
					<img src={webinar.image_url} alt="" className="w-[200px] rounded-[10px]" />
				</div>
				<div className="spacer p-[10px]"></div>
				<div>
					<div className="font-Vazir-700 text-[16px] text-[#666666]">{webinar.title}</div>
					<div className="spacer p-[3px]"></div>
					<div
						className={[
							"font-Vazir-400 text-[14px]",
							instructor.isEmpty ? "text-[#999999]" : "text-[#666666]",
						].join(" ")}
					>
						{instructor.subtitle}
					</div>
				</div>
			</div>
		</div>
	)
}
